import endpointVersion from '@/helpers/endpoint-version';
import store from '@/store';
import axios from 'axios';
export async function apiPasswordUpdate(password, token) {
    const data = { user_password: password };
    const response = await axios.post('/user/passwordUpdate', data, {
        baseURL: endpointVersion('v3'),
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
}
export async function apiValidateTemporaryPassword(email, password) {
    const tokenV3 = store.state.auth.tokenV3;
    const formData = new FormData();
    formData.append('login', email);
    formData.append('password', password);
    const response = await axios.post('/auth/login', formData, {
        baseURL: endpointVersion('v3'),
        headers: {
            'content-type': 'multipart/form-data',
            Authorization: `Bearer ${tokenV3}`,
        },
    });
    return response.data;
}
